import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { AttachmentChip } from "./AttachmentChip";
import type { AttachmentItem } from "./types";

interface AttachmentListProps {
  attachments: AttachmentItem[];
  className?: string;
  onRemove?: (id: string) => void;
}

export const AttachmentList = ({
  attachments,
  className,
  onRemove,
}: AttachmentListProps) => {
  if (attachments.length === 0) return null;

  return (
    <div className={classNames("flex flex-wrap gap-2", className)}>
      {attachments.map(item => (
        <AttachmentChip key={item.id} attachment={item} onRemove={onRemove} />
      ))}
    </div>
  );
};
